import {
  LibrariesCreate,
  LibrariesEdit,
  LibrariesList,
  LibrariesShow
} from 'pages/teaching_resources/libraries';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'libraries',
  label: 'Bibliotecas',
  list: LibrariesList,
  create: LibrariesCreate,
  show: LibrariesShow,
  edit: LibrariesEdit,
  actions: ['list', 'show', 'create', 'edit'],
  parentName: 'teaching_resources'
};

export default generateResources(resource);
